import { useTranslation } from 'react-i18next';
import { AppUtils } from '@/utils/app';

type Props = {
    floorName: string;
    categoryOnFloor: string;
    isShowAllFloorGuide: boolean;
};

export const VerticalMapHeader = ({ floorName, categoryOnFloor, isShowAllFloorGuide }: Props) => {
    const { t } = useTranslation();

    return (
        <section className="bg-bg-gray-f9 border-not-contrast-bg-gray-f9 fullscreen:h-[calc(280*var(--vh-unit))] h-[calc(220*var(--vh-unit))] w-full border-b border-solid pl-[calc(56*var(--vh-unit))]">
            {!isShowAllFloorGuide ? (
                <div className="mt-[calc(90*var(--vh-unit))] flex items-center justify-start gap-[calc(20*var(--vh-unit))]">
                    <p
                        data-region-nav
                        data-region-order={1}
                        className="text-text-main01 text-[calc(96*var(--vh-unit))] leading-[calc(100*var(--vh-unit))] focus-border "
                        tabIndex={1}
                        data-interactive
                        aria-label={t('floor_guide.text_to_speech.floor', { floorName: AppUtils.getFloorTTSText(floorName) })}
                    >
                        {floorName}
                    </p>
                    <p
                        data-region-nav
                        data-region-order={2}
                        className="text-text-main01 text-[calc(28*var(--vh-unit))] leading-[calc(34*var(--vh-unit))] focus-border "
                        tabIndex={2}
                        data-interactive
                        aria-label={categoryOnFloor}
                    >
                        {categoryOnFloor || <span>&nbsp;</span>}
                    </p>
                </div>
            ) : (
                <p tabIndex={1} data-interactive aria-label={t('floor_guide.label.all_floors_guide')} className="text-text-main01 mt-[calc(86*var(--vh-unit))] text-center text-[calc(60*var(--vh-unit))] leading-[calc(90*var(--vh-unit))] font-bold focus-border all-floor-guide-title">
                    {t('floor_guide.label.all_floors_guide')}
                </p>
            )}
        </section>
    );
};
